export class GuidSanitizer {
    public removeGuidBrackets(guid?: string) {
        return guid?.replace?.("{", "")?.replace?.("}", "")?.toLowerCase?.() ?? "";
    }
}